module.exports = __webpack_public_path__ + "img/DE01768.43e0a3cc.png";